module.exports = __webpack_public_path__ + "img/so_bussiness.c347d37b.png";